import { useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

import AlertWithIcon from '../AlertWithIcon';
import { P2GLinkGroup, P2GLink } from '@parcel2go/core-ui';

interface props {
  item: SmartSendItemApiModel;
}

export const CustomerAddressMessage: React.FC<props> = (props) => {
  const obscured = useMemo(() => JSON.stringify(props.item.Recipient).indexOf('****') > -1, [props.item.Recipient]);

  const mps = useMemo(
    () => props.item.MarketplaceOrderLines.map((x) => x.Source?.Id),
    [props.item.MarketplaceOrderLines]
  );

  if (obscured && mps.includes('tiktok')) {
    return (
      <AlertWithIcon color="warning">
        Choose "<strong>send by seller</strong>" as the delivery method when listing items on TikTok to import the
        buyer's full address.
        <P2GLinkGroup
          pt={1}
          links={[
            <P2GLink
              target="_blank"
              href="https://partner.tiktokshop.com/doc/faqs/7176589485650565634?faq_id=7174712088336538118&no_locate=1"
            >
              See TikTok for Details
            </P2GLink>
          ]}
        />
      </AlertWithIcon>
    );
  }

  return null;
};
